import React from "react"
import { useTranslation } from "react-i18next"

import classNames from "classnames"

import { IconSize } from "shared/types/Icon"
import { Button, ButtonVariant } from "shared/ui/buttons/Button"
import { IconName } from "shared/ui/icon/__generated__/IconName"

import { useProductPageContext } from "../context/ProductPageContext"

export const ProductPageFavoriteButton = React.memo(() => {
  const { t } = useTranslation()
  const { onToggleFavorite, isAuthenticated, isFavorited } =
    useProductPageContext()

  if (!isAuthenticated) {
    return null
  }

  return (
    <Button
      id="product-page__favorite-button"
      variant={ButtonVariant.SECONDARY}
      isIconOnly
      label={
        isFavorited
          ? t("Favorites.Actions.Delete")
          : t("Favorites.Actions.Create")
      }
      disabled={!onToggleFavorite}
      onClick={onToggleFavorite}
      className={classNames(
        "product-page__favorite-button btn--bleed btn--borderless",
        { "product-page__favorite-button--is-favorite": isFavorited }
      )}
      icon={isFavorited ? IconName.HEART_SOLID : IconName.HEART}
      iconSize={IconSize.LARGE}
    />
  )
})
